export const ugovor_o_donaciji = {
    templateId: 49.3,
    category: 5,
    templateTitle: "Ugovor o donaciji",
    templateDescription: `<p>Ugovor o donaciji poseban je oblik darovanja kojim poslovni subjekt daje stvar, uslugu ili novac primatelju donacije bez ikakve protučinidbe.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Ugovor o donaciji je ustvari u pravnom smislu ugovor koji sadrži elemente ugovora o darovanju koji je reguliran Zakonom o obveznim odnosima. </p>
    <p>Darovanje je davanje dara u novcu, stvarima ili uslugama primatelju bez ikakve naknade ili protučinidbe. </p>
    <p>Razlika u odnosu na sponzorstvo je u tome što kod sponzorstva primatelj daje određenu protučinidbu sponzoru, dok kod donacije primatelj donacije ne daje nikakvu protučinidbu. </p>
    <p>Kako bi darovanje za <strong>obveznike Poreza na dobit</strong> bilo računovodstveno neoporezivo i tretirano kao porezno priznati rashod, nužno je ispuniti barem jedan od uvjeta: </p>
    <li> darovanje mora biti učinjeno u tuzemstvu za kulturne, znanstvene, odgojno-obrazovne, zdravstvene, humanitarne, sportske, vjerske, ekološke i druge općekorisne svrhe udrugama i drugim osobama koje navedene djelatnosti obavljaju u skladu s posebnim propisima (liječnici, umjetnici i sl.),</li>
    <li> svrha darovanja je plaćanje troškova za zdravstvene potrebe fizičkih osoba (operativne zahvate, liječenja, nabavu lijekova i ortopedskih pomagala te troškove prijevoza i smještaja u zdravstvene ustanove) rješavanje kojih nije plaćeno osnovnim, dopunskim, dodatnim i privatnim zdravstvenim osiguranjem niti na teret sredstava fizičke osobe, a pod uvjetom da je darovanje odnosno plaćanje troškova obavljeno na žiro-račun primatelja dara ili zdravstvene ustanove te na temelju vjerodostojnih isprava (tako se mogu darivati i radnici poslodavca sukladno mišljenju Porezne uprave Broj: 410-01/16-01/01514 od 17.05.2016. godine), </li>
    <br>
    <p>pri čemu takvo neoprezivo darovanje može biti do iznosa od 2% prihoda ostvarenog u prethodnoj godini. Iznimno, svota može biti i veća od 2% prihoda prethodne godine ako je dana prema odlukama nadležnih ministarstva o provedbi financiranja posebnih programa i akcija  provedenim prema posebnim propisima Ministarstva poljoprivrede. </p>
    <p>U gore navedena darovanja mogu se uključiti i darovanja poreznih obveznika proizvođača i trgovaca hrane koji, u cilju sprečavanja uništavanja velikih količina hrane i zaštite okoliša, daruju hranu gore navedenim osobama za socijalne, humanitarne i druge svrhe pomoći te osobama pogođenim elementarnim nepogodama i prirodnim katastrofama, pod uvjetom da su ta darovanja izvršena u skladu s posebnim propisima Ministarstva poljoprivrede.    </p>
    <p>Kod sponzorstva nema navedenih ograničenja, kako u pogledu iznosa, tako i u pogledu ispunjavanju određenih uvjeta te se ista smatraju porezno priznatim troškom u cijelosti. </p>
    <p>Kao što je gore spomenuto, prethodno opisano odnosi se na obveznike Poreza na dobit.</p>
    <p><strong>Obveznik Poreza na dohodak</strong> može uvećati osobni odbitak za darovanja dana u tuzemstvu u naravi i u novcu doznačenim na žiro-račun učinjenim u tuzemstvu za kulturne, znanstvene, odgojno-obrazovne, zdravstvene (operativni zahvati, liječenja, nabava lijekova i ortopedskih pomagala te troškovi prijevoza i smještaja u zdravstvene ustanove), humanitarne, sportske, vjerske, ekološke i druge općekorisne svrhe udrugama i drugim osobama koje navedene djelatnosti obavljaju u skladu s posebnim propisima (liječnici, umjetnici i sl.),  do visine 2% primitaka za koje je u prethodnoj godini podnesena godišnja porezna prijava i utvrđen godišnji porez na dohodak. Iznimno, osobni odbitak se uvećava za darovanja dana iznad propisane visine, pod uvjetom da su dana prema odlukama nadležnih ministarstava o provedbi i financiranju posebnih programa i akcija, ali ne i za redovnu djelatnost primatelja darovanja. </p>
    <p>No, s druge strane,  darovanje pravnih i fizičkih osoba izvršeno od strane obveznika poreza na dohodak za zdravstvene potrebe, suprotno od obveznika poreza na dobit, ne može se odbiti niti kao izdatak,  a niti kao osobni odbitak. </p>  
    <p><strong>Važno je naglasiti da se za obveznike poreza na dobit (trgovačka društva, osobe koje obavljaju samostalnu djelatnost – „dobitaši“)  darovanja smatraju troškovima poslovanja (porezno priznatim ili porezno nepriznatim, ovisno o ispunjenju uvjeta), u sustavu poreza na dohodak darovanja se ne smatraju izdatkom već u pojedinim slučajevima samo osobnim odbitkom.</strong></p>
    <p>Kako bi darovanje, kao poslovni događaj, bilo što vjerodostojnije dokumentirano uputno je da donator pribavi neke od sljedećih dokumenata: pismeni zahtjev (molba) za donaciju, odluku o darovanju (donaciji) ili ugovor o darovanju (donaciji). </p>
    <p>Sukladno Općem poreznom zakonu, bilježenje podataka u poslovne knjige mora se temeljiti na urednim i vjerodostojnim knjigovodstvenim ispravama. </p>
    <p>Smatra se da je isprava za knjiženje uredna kad se iz nje nedvosmisleno može utvrditi mjesto i vrijeme njezina sastavljanja i njezin materijalni sadržaj, što znači narav, vrijednost i vrijeme nastanka poslovne promjene povodom koje je sastavljena.  </p>
    <p>U tom smislu je za:</p>
    <li> darovanje u novcu potrebno osigurati izvod sa žiro-računa ili blagajničku isplatnicu,</li>
    <li> darovanje u stvarima ili uslugama otpremnicu, dostavnicu ili neku drugu  pisanu ispravu (ugovor) o obavljenoj primopredaji dara.</li>
    <br>
    <p>Na darovanje koje se vrši u novcu ne obračunava se PDV. </p>
    <p>Međutim, ako se darovanje vrši u stvarima ili uslugama, donator koji je obveznik PDV-a je obvezan obračunati PDV na tržišnu vrijednost darovanja, osim u slučajevima koje propisuje Zakon o porezu na dodanu vrijednost odnosno Pravilnik o porezu na dodanu vrijednost (kod izuzimanja dobara u slučajevima kada se cijelosti ili djelomično mogao iskoristiti odbitak pretporeza te u slučajevima kod besplatnog davanja uzoraka i povremenog davanja darova).</p>
   
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima, Opći porezni zakon, Zakon o porezu na dobit, Pravilnik po porezu na dobit, Zakon o porezu na dodanu vrijednost, Pravilnik o porezu na dodanu vrijednost, Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>    
  `,

    sides: [
        {
            signature: 'Donator:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Poslovni subjekt',
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija",
                    inSignature: true,
                }],
            suffix: ' (u daljnjem tekstu: Donator)',
            delimiter: `i`
        },
        {
            signature: 'Primatelj donacije:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Naziv. prim. donacije',
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija",
                    inSignature: true,
                }],
            suffix: ' (u daljnjem tekstu: Primatelj donacije),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O DONACIJI',
    noArticleNumbers: false,

    articles: [

        {
            title: 'PREDMET UGOVORA',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovim Ugovorom, Donator se obvezuje bez ikakve protučinidbe dati Primatelju donaciju u skladu s odredbama ovog Ugovora, a Primatelj donacije prihvaća donaciju.',
                    value: '',
                }],
        },
        {
            title: 'PREDMET DONACIJE',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Predmet donacije je novčani iznos od'},
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: ', a koji se Donator obvezuje uplatiti Primatelju donacije uplatom na račun'},
                                {
                                    type: 'text',
                                    content: 'otvoren kod'
                                },
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: 'd.d..'},
                                {help: 'Upišite naziv banke u kojoj Primatelj donacije ima otvoren račun.'}
                            ]},
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Predmet donacije je donacija stvari, i to:'
                                },
                                {type: 'textarea', value: '', required: true,},
                              ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Predmet donacije je donacija sljedećih usluga:'
                                },
                                {type: 'textarea', value: '', required: true,},]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'NAMJENA DONACIJE',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Primatelj donacije će donaciju koristiti u sljedeću namjenu:'},
                        {type: 'textarea', value: '', required: true,},
                      ],
                }],
            value: '',
        },
        {
            title: 'ROK REALIZACIJE',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Donacija će se realizirati u sljedećem roku:'},
                        {type: 'textarea', value: '', required: true,},
                     ],
                }],
            value: '',
        },
        {
            title: 'OBVEZE DONATORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Donator se obvezuje donirati Primatelju predmet donacije kako je to određeno odredbama ovog Ugovora.',
                    value: '',
                }],
        },
        {
            title: 'OBVEZE PRIMATELJA DONACIJE',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Primatelj donacije se obvezuje predmet donacije koristiti u skladu s namjenom određenom ovim Ugovorom.',
                    value: '',
                }],
        },
        {
            title: 'OBVEZE POVRATA DONACIJE',
            mandatory: false,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'U slučaju nepotpuno izvršene obveze Primatelja donacije na korištenje predmeta donacije u skladu s namjenom, Primatelj donacije se obvezuje naknaditi štetu Donatoru u iznosu od ___ kn.',
                    value: '',
                }],
        },
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Donatora.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Primatelja donacije.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                                ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }],
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/49.3_ugovor_o_donaciji.ts